// contexts/NavigationBlockerContext.js
import { createContext, useContext, useRef } from "react";

const NavigationBlockerContext = createContext();

export const NavigationBlockerProvider = ({ children }) => {
  const shouldBlockRef = useRef(false);

  const enableBlock = () => (shouldBlockRef.current = true);
  const disableBlock = () => (shouldBlockRef.current = false);
  const isBlocking = () => shouldBlockRef.current;

  return (
    <NavigationBlockerContext.Provider
      value={{ enableBlock, disableBlock, isBlocking }}
    >
      {children}
    </NavigationBlockerContext.Provider>
  );
};

export const useNavigationBlocker = () => useContext(NavigationBlockerContext);
